import {create} from 'zustand';

const useBgColorStore = create((set) => ({

    currentColorClass: 'bg-beige',

    setColorClass: (currentColorClass = 'bg-beige') => set({ currentColorClass }),

}));

export default useBgColorStore;